import React from "react";
import Header from "./Header";
import AgreementList from "../agreements/AgreementList";

export default function LayoutAgreements() {
  return (
    <>
      <Header />
      <AgreementList />
    </>
  );
}
